import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "@/providers/auth-provider";
import { getDexList, getDexDetails, claimDexReward } from "@/services/dex/dex";
import { queryKeys } from "./query-keys";

export const useDexList = () => {
  const { state } = useAuth();
  return useQuery({
    queryKey: queryKeys.dex,
    queryFn: async () => {
      const response = await getDexList();
      if (!response.ok) throw new Error(response.message);
      return response.data;
    },
    enabled: state.status === "authenticated",
  });
};

export const useDexDetails = (setId: string | null) => {
  const { state } = useAuth();
  return useQuery({
    queryKey: queryKeys.dexDetails(setId ?? ""),
    queryFn: async () => {
      const response = await getDexDetails(setId!);
      if (!response.ok) throw new Error(response.message);
      return response.data;
    },
    enabled: state.status === "authenticated" && Boolean(setId),
  });
};

export const useClaimDexReward = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: claimDexReward,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.dex });
    },
  });
};
